import axios from "axios";
import config from "../config";

const axiosInstance = axios.create({
  baseURL: config.backend_Url,
});

// 🔑 Attach token automatically
axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;